import { Button } from 'components/common/SaveButton/components';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import { HeartIcon } from 'components/common/HeartIconContainer';
import { Spin } from 'antd';
import useCreditBookmarks from 'hooks/use-credit-bookmarks';
import useMetadata from 'hooks/use-metadata';

type Props = {
  creditItemID: string;
  creditType: CreditType;
};

export function SaveButton(props: Props): JSX.Element {
  const { creditItemID, creditType } = props;
  const { creditBookmarks, addCreditBookmark, removeCreditBookmark } = useCreditBookmarks();
  const metadata = useMetadata();

  if (!metadata) {
    return <Spin />;
  }

  const existsInBookmarks = creditBookmarks.has(creditItemID);

  const ariaLabel = existsInBookmarks
    ? 'This credit is marked as saved. Click again to unsave it.'
    : 'This credit is not marked as saved. Click to save it to the saved list.';
  const onBookmarkClick = () => {
    if (existsInBookmarks) {
      removeCreditBookmark(creditItemID);
      return;
    }
    addCreditBookmark({ creditItemID, creditType, timestamp: metadata.timestamp });
  };

  return (
    <Button onClick={onBookmarkClick} className='save-button' aria-label={ariaLabel}>
      <FlexContainer flexDirection='row' alignItems='center' gap={8}>
        <HeartIcon
          size={16}
          className={existsInBookmarks ? 'heart-icon-filled' : 'heart-icon-outline'}
          selected={existsInBookmarks}
        />
        <span>{existsInBookmarks ? 'Remove from saved' : 'Save credit'}</span>
      </FlexContainer>
    </Button>
  );
}
